import { Component, OnInit } from '@angular/core';

import { distinctUntilChanged, map } from 'rxjs/operators';

import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import AlphaYearFacade from '@app/core/facades/alpha-year.facade';
import FilterComponent from '@app/shared/filters/filter.component';
import FilterChange from '@app/shared/filters/filter-change.model';

const SIZE = '190px';

@Component({
  selector: 'app-filter-alpha-years',
  templateUrl: '../filter.component.html',
  styleUrls: ['../filter.component.scss'],
})
export default class AlphaYearsFilterComponent extends FilterComponent implements OnInit {
  public readonly label = 'Years at Alpha';
  public readonly width = SIZE;

  constructor(private readonly _data: AlphaYearFacade) {
    super();
  }

  public update(value: string, global = true): void {
    this._data.updateYear(value, global);
    this.valueChange.emit(new FilterChange(FilterType.YearAtAlpha, value));
  }

  ngOnInit() {
    this.options$ = (
      !!this.config.transform ? this.config.transform(this._data.yearsAtAlpha$) : this._data.yearsAtAlpha$
    ).pipe(
      distinctUntilChanged(),
      map((options: Array<{ [key: string]: string }>) =>
        options?.map((option) => ({ label: `${option.yearAtAlpha} YEARS`, value: option.yearAtAlpha }))
      )
    );

    this.initDefaultValues(this._data.selected$);
  }
}
